import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; 
import 'primereact/resources/primereact.min.css'; 
import "primereact/resources/themes/lara-light-cyan/theme.css";
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import Home from './Screen/Home'
import Blogs from './Screen/Blogs'
import Blog1 from './Blogs/Blog1'
import Blog2 from './Blogs/Blog2'
import Blog3 from './Blogs/Blog3'
import Blog4 from './Blogs/Blog4'
import Blog5 from './Blogs/Blog5'
import Selectserives from './Screen/Selectserives'
import Test from './Screen/Test';
import Selectsubserives from './Screen/Selectsubserives'
import Finalform from './Screen/Finalform'
import SelectrealEaste from './Screen/SelectrealEaste'
import FinancialService from './Screen/FinancialService'
import Manufacturing from './Screen/Manufacturing'
import Automotive from './Screen/Automotive'
import Ecommers from './Screen/Ecommers'
import Appointment from '../src/Screen/Appointment'
import Thankyou from './Screen/Thankyou'
import AfterPayment from './Screen/AfterPayment'
import Subscription from './Screen/Subscription'
import UsersAppointment from './Screen/UsersAppointment'
import Signup from './Screen/Signup'
import Payment from './Screen/Payment'
import Contactus from './Screen/Contactus'
import TermsandCondition from './components/TermsandCondition'
import PrivacyPolicy from './components/PrivacyPolicy'
import ReturnPolicy from './components/ReturnPolicy'
import ShippingPolicy from './components/ShippingPolicy'
import RefundandCancellationpolicy from './components/RefundandCancellationpolicy'
import Blog6 from './Blogs/Blog6';
import Blog7 from './Blogs/Blog7';
import Blog8 from './Blogs/Blog8';
import Blog9 from './Blogs/Blog9';
import Blog10 from './Blogs/Blog10';
import Blog11 from './Blogs/Blog11';
import Blog12 from './Blogs/Blog12';
import Blog13 from './Blogs/Blog13';
import Blog14 from './Blogs/Blog14';
import Blog15 from './Blogs/Blog15';
import Blog16 from './Blogs/Blog16';
import Blog17 from './Blogs/Blog17';
import Blog18 from './Blogs/Blog18';
import Blog19 from './Blogs/Blog19';
import Blog20 from './Blogs/Blog20';
import Blog26 from './Blogs/Blog26';
import Blog27 from './Blogs/Blog27';
import Blog28 from './Blogs/Blog28';
import Blog24 from './Blogs/Blog24';
import Blog25 from './Blogs/Blog25';
import Blog21 from './Blogs/Blog21';
import Blog22 from './Blogs/Blog22';
import Blog23 from './Blogs/Blog23';
import BlogUAE1 from './BlogsUAE/BlogUAE1';
import BlogUAE2 from './BlogsUAE/BlogUAE2';
import BlogUAE3 from './BlogsUAE/BlogUAE3';
import BlogUAE4 from './BlogsUAE/BlogUAE4';
import BlogUAE5 from './BlogsUAE/BlogUAE5';
import BlogUAE6 from './BlogsUAE/BlogUAE6';



function App() {
  return (
    <div>
      <Router>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/blogs' element={<Blogs/>}/>
          <Route path='/selectservices' element={<Selectserives/>}/>
          <Route path='/selectsubserives' element={<Selectsubserives/>}/>
          <Route path='/selectrealEaste' element={<SelectrealEaste/>}/>
          <Route path='/financialService' element={<FinancialService/>}/>
          <Route path='/manufacturing' element={<Manufacturing/>}/>
          <Route path='/movers' element={<Automotive/>}/>
          <Route path='/ecommers' element={<Ecommers/>}/>
          <Route path='/finalform' element={<Finalform/>}/>
          <Route path='/appointment' element={<Appointment/>}/>
          <Route path='/thankyou' element={<Thankyou/>}/>
          <Route path='/successpayment' element={<AfterPayment/>}/>
          <Route path='/blaccdot-pricing' element={<Subscription/>}/>
          <Route path='/signup' element={<Signup/>}/>
          <Route path='/payment' element={<Payment/>}/>
          <Route path='/terms-and-conditions' element={<TermsandCondition/>}/>
          <Route path='/privacy-policy' element={<PrivacyPolicy/>}/>
          <Route path='/refund-and-cancellation-policy' element={<RefundandCancellationpolicy/>}/>
          <Route path='/return-policy' element={<ReturnPolicy/>}/>
          <Route path='/shipping-policy' element={<ShippingPolicy/>}/>
          <Route path='/users-appointment' element={<UsersAppointment/>}/>
          <Route path = 'blogs/real-estate/how-to-get-serious-property-buyers-in-dubai-without-wasting-money-on-ads' element={<BlogUAE1/>}/>
           <Route path = 'blogs/real-estate/why-am-i-getting-enquiries-but-no-property-buyers-in-UAE?' element={<BlogUAE2/>}/>
           <Route path = 'blogs/real-estate/how-do-real-estate-developers-in-UAE-find-verified-buyers?' element={<BlogUAE3/>}/>
           <Route path = 'blogs/real-estate/how-to-sell-off-plan-property-faster-in-dubai' element={<BlogUAE4/>}/>
           <Route path ="blogs/real-estate/how-to-generate-real-estate-leads-in-dubai-in-2026"element={<BlogUAE5/>}/>
           <Route path = 'blogs/real-estate/why-meta-and-google-ads-fail-to-deliver-quality-property-buyers-in-UAE' element={<BlogUAE6/>}/>
          <Route path='/contact-us' element={<Contactus/>}/>
          <Route path='blogs/e-commerce/10-lean-strategies-to-boost-e-commerce-roas' element={<Blog1/>}/>
          <Route path='blogs/real-estate/from-clicks-to-visits-lean-strategies-to-convert-real-estate-leads-into-property-viewings' element={<Blog2/>}/>
          <Route path='blogs/real-estate/7-game-changing-tips-to-attract-high-quality-leads-with-meta-ads' element={<Blog3/>}/>
          <Route path='blogs/real-estate/11-proven-ways-to-attract-high-quality-leads-using-google-ads-2024' element={<Blog4/>}/>
          <Route path='blogs/e-commerce/how-to-generate-leads-on-a-zero-marketing-budget-b2c-and-b2b-strategies' element={<Blog5/>}/>
          <Route path='blogs/health/8-proven-ways-to-get-more-leads-for-your-dental-clinic' element={<Blog6/>}/>
          <Route path='blogs/real-estate/google-ads-vs-meta-ads-which-is-better-for-real-estate-lead-generation-in-india-2025' element={<Blog7/>}/>
          <Route path='blogs/real-estate/7-proven-ways-to-generate-real-estate-leads-with-google-ads-blaccdot' element={<Blog8/>}/>
          <Route path='blogs/real-estate/biggest-real-estate-lead-generation-challenges-in-india-and-solutions' element={<Blog9/>}/>
          <Route path='blogs/real-estate/how-to-create-a-winning-real-estate-leads-funnel-in-india-for-higher-sales' element={<Blog10/>}/>
          <Route path = 'blogs/real-estate/real-estate-follow-up-strategies-chennai' element={<Blog11 />} />
          <Route path = 'blogs/real-estate/real-estate-lead-follow-up-timeline-chennai' element={<Blog12 />}/>
          <Route path = 'blogs/real-estate/nurture-real-estate-leads-chennai' element={<Blog13/>}/>
          <Route path = 'blogs/real-estate/7-day-follow-up-plan-chennai-real-estate' element={<Blog14/>}/>
          <Route path = 'blogs/real-estate/real-estate-lead-trust-building-chennai' element={<Blog15/>}/>
          <Route path = 'blogs/real-estate/lead-generation-for-luxury-properties-in-chennai' element={<Blog16/>}/>
          <Route path = 'blogs/real-estate/atl-vs-btl-vs-ttl-marketing-real-estate-lead-generation' element={<Blog17/>}/>
          <Route path = 'blogs/real-estate/real-estate-lead-generation-tier-2-3-cities-india' element={<Blog18/>}/>
          <Route path = 'blogs/real-estate/best-real-estate-meta-ads-creative-lead-generation' element={<Blog19/>}/>
          <Route path = 'blogs/real-estate/indian-real-estate-lead-generation-trends-2026' element={<Blog20/>}/>
           <Route path = 'blogs/real-estate/whatsapp-follow-up-real-estate-leads-india' element={<Blog21/>}/>
          <Route path = 'blogs/real-estate/real-estate-lead-generation-lowest-cpl-meta-ads' element={<Blog22/>}/>
          <Route path = 'blogs/real-estate/meta-andromeda-update-real-estate-lead-generation' element={<Blog23/>}/>
          <Route path = 'blogs/real-estate/real-estate-buyer-personas-chatgpt-india' element={<Blog24/>}/>
          <Route path = 'blogs/real-estate/property-videos-high-intent-lead-generation-india' element={<Blog25/>}/>
          <Route path = 'blogs/real-estate/how-blaccdot-helps-real-estate-channel-partners-india' element={<Blog26/>}/>
          <Route path = 'blogs/real-estate/ai-real-estate-lead-generation-india-2026' element={<Blog27/>}/>
          <Route path = 'blogs/real-estate/real-estate-ai-lead-followup-india' element={<Blog28/>}/>
          
          <Route path='/test' element={<Test/>}/>
          </Routes>
       </Router>

    </div>
  );
}

export default App;

<></>
